import PrimeChart from 'primevue/chart'

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const __default__ = {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  computed: {
    chart_data(){
      const last_six = this.data.slice(-6)
      return {
        labels: last_six
          .map(el => `${months[new Date(el.date).getMonth()]} ${String(new Date(el.date).getYear()).slice(-2)}`),
        datasets: [
          {
            data: last_six.map(el => el.value),

            borderColor: '#595857',
            borderWidth: 2,
            tension: 0.4,

            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0,

            // background
            fill: true,
            backgroundColor: 'rgba(240, 238, 235, 0.5)',
          }
        ]

      }
    },
    chart_opt() {
      return {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          },
        },
        scales: {
          x: {
            ticks: {
              color: '#8C8C8C'
            },
            grid: {
              drawOnChartArea: false,
              drawTicks: true,
            }
          },
          y: {
            ticks: {
              color: '#8C8C8C'
            },
            grid: {
              color: ctx => ctx.index > 0 ? '#d5d9e0' : 'transparent' 
            },
            border: {
              dash: []
            }, 
          }
        }
      }
    }
  },
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'chart',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { months, get PrimeChart() { return PrimeChart } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})